export const MAIN_THEME_COLOR = '#28696D';
export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
export const GREY = '#A6A5A5';
export const teal = '#00c4b4';
export const dark = '#0f2e2e';
export const border = '#d8e8e8';
export const surface = '#f5fafa';
